export const BASE_URL = process.env.REACT_APP_URL_BASE
export const DOMAIN_URL = process.env.REACT_APP_URL_DOMAIN
